import { store } from "quasar/wrappers";
import { createPinia } from "pinia";

export default store(({ ssrContext }) => {
  const pinia = createPinia();

  if (process.env.SERVER) {
    (ssrContext as any).state = (ssrContext as any).state || {};
    (ssrContext as any).state.pinia = pinia.state.value;
  }

  if (process.env.CLIENT) {
    if ((window as any).__INITIAL_STATE__?.pinia) {
      pinia.state.value = (window as any).__INITIAL_STATE__.pinia;
    }
  }

  return pinia;
});
